import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withModifiers as _withModifiers, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-61d02e3b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container-fluid" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = ["onDrop"]
const _hoisted_4 = { style: {"margin-top":"20px"} }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { id: "dragDrop" }, "Drag & Drop file", -1 /* HOISTED */))
const _hoisted_6 = {
  class: "btn btn-primary button-width button-color",
  for: "inputFile"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-folder" }, null, -1 /* HOISTED */))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  style: {"margin-left":"5px"},
  for: "inputFile"
}, "Select file", -1 /* HOISTED */))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  id: "btnGarbledShow",
  style: {"visibility":"hidden"},
  "data-bs-toggle": "modal",
  "data-bs-target": "#showGarbledModal"
}, null, -1 /* HOISTED */))
const _hoisted_10 = {
  key: 0,
  class: "get-list"
}
const _hoisted_11 = { class: "table" }
const _hoisted_12 = { align: "left" }
const _hoisted_13 = ["onClick"]
const _hoisted_14 = { style: {"margin-top":"20px","display":"flex"} }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-caret-left-fill" }, null, -1 /* HOISTED */))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { style: {"margin-left":"5px"} }, "Back", -1 /* HOISTED */))
const _hoisted_17 = [
  _hoisted_15,
  _hoisted_16
]
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-upload" }, null, -1 /* HOISTED */))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { style: {"margin-left":"5px"} }, "Upload", -1 /* HOISTED */))
const _hoisted_20 = [
  _hoisted_18,
  _hoisted_19
]
const _hoisted_21 = {
  key: 1,
  type: "button",
  class: "btn btn-primary button-margin button-width button-color",
  disabled: ""
}
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-upload" }, null, -1 /* HOISTED */))
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { style: {"margin-left":"5px"} }, "Upload", -1 /* HOISTED */))
const _hoisted_24 = [
  _hoisted_22,
  _hoisted_23
]
const _hoisted_25 = {
  class: "modal fade",
  id: "showGarbledModal",
  tabindex: "-1",
  "aria-labelledby": "showModalLabel",
  "aria-hidden": "true",
  style: {"width":"45%","margin-left":"32.5%","height":"fit-content"}
}
const _hoisted_26 = { class: "modal-dialog modal-dialog-scrollable modal-lg" }
const _hoisted_27 = { class: "modal-content" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "modal-header" }, [
  /*#__PURE__*/_createElementVNode("button", {
    type: "button",
    class: "btn-close",
    "data-bs-dismiss": "modal",
    "aria-label": "Close"
  })
], -1 /* HOISTED */))
const _hoisted_29 = {
  class: "modal-body",
  id: "divGarbleError",
  style: {"text-align":"left","font-size":"16px","overflow-x":"hidden"}
}
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "modal-footer" }, [
  /*#__PURE__*/_createElementVNode("button", {
    type: "button",
    id: "btnDelete",
    class: "btn btn-primary button-design",
    style: {"width":"78px","height":"35px","text-align":"center"},
    "data-bs-dismiss": "modal"
  }, " OK ")
], -1 /* HOISTED */))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      ($setup.isLoading)
        ? (_openBlock(), _createBlock($setup["Loading"], {
            key: 0,
            isLoading: $setup.isLoading
          }, null, 8 /* PROPS */, ["isLoading"]))
        : _createCommentVNode("v-if", true),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", {
          class: _normalizeClass(["drop-area", $setup.isEnter ? 'drop-area-over' : 'drop-area-leave']),
          onDragenter: _cache[1] || (_cache[1] = ($event: any) => ($setup.isEnter = true)),
          onDragleave: _cache[2] || (_cache[2] = ($event: any) => ($setup.isEnter = false)),
          onDragover: _cache[3] || (_cache[3] = _withModifiers(($event: any) => ($setup.isEnter = true), ["prevent"])),
          onDrop: _withModifiers($setup.selectFile, ["prevent"])
        }, [
          _createElementVNode("div", _hoisted_4, [
            _hoisted_5,
            _createElementVNode("label", _hoisted_6, [
              _hoisted_7,
              _hoisted_8,
              _createElementVNode("input", {
                type: "file",
                id: "inputFile",
                style: {"display":"none"},
                onChange: $setup.selectFile,
                onClick: _cache[0] || (_cache[0] = (e) => {
                e.target.value = '';
              }
              ),
                multiple: ""
              }, null, 32 /* HYDRATE_EVENTS */)
            ]),
            _hoisted_9
          ]),
          ($setup.uploadFiles.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                _createElementVNode("table", _hoisted_11, [
                  _createElementVNode("tbody", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.uploadFiles, (file, index) => {
                      return (_openBlock(), _createElementBlock("tr", {
                        key: index,
                        valign: "top"
                      }, [
                        _createElementVNode("td", _hoisted_12, _toDisplayString(file.name), 1 /* TEXT */),
                        _createElementVNode("td", null, [
                          _createElementVNode("button", {
                            type: "button",
                            class: "btn-close",
                            onClick: ($event: any) => ($setup.fileCancel(index))
                          }, null, 8 /* PROPS */, _hoisted_13)
                        ])
                      ]))
                    }), 128 /* KEYED_FRAGMENT */))
                  ])
                ])
              ]))
            : _createCommentVNode("v-if", true)
        ], 42 /* CLASS, PROPS, HYDRATE_EVENTS */, _hoisted_3),
        _createElementVNode("div", _hoisted_14, [
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-secondary button-margin button-width",
            onClick: _cache[4] || (_cache[4] = ($event: any) => ($setup.linkPcDownload()))
          }, _hoisted_17),
          ($setup.isActive === true)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                type: "button",
                class: "btn btn-primary button-margin button-width button-color",
                onClick: _cache[5] || (_cache[5] = ($event: any) => ($setup.changeLoading()))
              }, _hoisted_20))
            : _createCommentVNode("v-if", true),
          ($setup.isActive === false)
            ? (_openBlock(), _createElementBlock("button", _hoisted_21, _hoisted_24))
            : _createCommentVNode("v-if", true)
        ])
      ])
    ]),
    _createCommentVNode(" Garbled Character Error Show Modal "),
    _createElementVNode("div", _hoisted_25, [
      _createElementVNode("div", _hoisted_26, [
        _createElementVNode("div", _hoisted_27, [
          _hoisted_28,
          _createElementVNode("div", _hoisted_29, _toDisplayString($setup.garbledError), 1 /* TEXT */),
          _hoisted_30
        ])
      ])
    ])
  ], 64 /* STABLE_FRAGMENT */))
}